"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
const _excluded = ["title", "description"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const cvv = _ref => {
  let {
      title,
      description
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? "title-cvv" : '') + (description ? " desc-cvv" : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-cvv"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-cvv"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M37 0.130005H3C1.89543 0.130005 1 1.02544 1 2.13V21.88C1 22.9846 1.89543 23.88 3 23.88H37C38.1046 23.88 39 22.9846 39 21.88V2.13C39 1.02544 38.1046 0.130005 37 0.130005Z",
    fill: "#C0C0C0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39 4.87H1V8.43H39V4.87Z",
    fill: "#505050"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.94 17.94H34.25V15.57H25.94V17.94Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 20.5C34.1421 20.5 37.5 18.933 37.5 17C37.5 15.067 34.1421 13.5 30 13.5C25.8579 13.5 22.5 15.067 22.5 17C22.5 18.933 25.8579 20.5 30 20.5Z",
    stroke: "#FF0000",
    fill: "white"
  }));
};
var _default = exports.default = cvv;